import analytics, { SEGMENT_EVENTS } from '@/utils/analytics';

const SEGMENT_EVENT_SEPARATORS = {
  NAME: '_',
  PROPERTY: '-',
};

export const sendSegmentTrackEvent = (
  routeName: string,
  eventNameSuffix: string,
  additionalData: any,
): void => {
  let eventName = `fe_${routeName.replace(
    /-/g,
    SEGMENT_EVENT_SEPARATORS.NAME,
  )}`;
  if (eventNameSuffix) {
    eventName += SEGMENT_EVENT_SEPARATORS.NAME + eventNameSuffix;
  }
  const eventData = {
    ...additionalData,
  };
  analytics.track(eventName as SEGMENT_EVENTS, eventData);
};

export const formatStepLabelForSegment = (
  label: string,
  isEventName?: boolean,
): string => {
  const eventSeparator = isEventName
    ? SEGMENT_EVENT_SEPARATORS.NAME
    : SEGMENT_EVENT_SEPARATORS.PROPERTY;
  let stepLabel = label.toLowerCase().replace(/ /g, eventSeparator);
  if (stepLabel.includes('&')) {
    stepLabel = stepLabel.substring(0, stepLabel.indexOf('&') - 1);
  }
  return stepLabel;
};
